import { jsx as _jsx } from "react/jsx-runtime";
import dompurify from "isomorphic-dompurify";
import { __ } from "@jti/fe-common";
const { sanitize } = dompurify;
export const OrderSummaryPageWarningMessage = ({ isFreeTrial, className, }) => {
    if (!isFreeTrial) {
        return null;
    }
    return (_jsx("div", { className: className, dangerouslySetInnerHTML: { __html: sanitize(__("cart.payment_summary.trial.infoText")) } }));
};
//# sourceMappingURL=OrderSummaryPageWarningMessage.js.map